module.exports = __webpack_public_path__ + "img/private.69ab1cd5.svg";